/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, parseTimeString, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";

import OzFormComponent from './OzFormComponent';
import WhereField from './WhereField';
import { AutocompleteField } from './EscapeForm';
import './AddToRegionForm.css';

import {
  listRegions
} from '../../actions';


class GiftCardForm extends OzFormComponent {

  static fields = [
    'giftCardUrl',
    'giftCardDiscount',
    'giftCardMessage',
  ];

  componentDidMount() {
  }

  renderBody() {
    return (
      <div className="GiftCardForm">
        {this.renderFormGroup('Gift card URL', 'text', 'giftCardUrl', { placeholder: 'https://...'})}
        {this.renderFormGroup('Gift discount %', 'selectNumber', 'giftCardDiscount', { helptext: 'Enter a number from 0-100', min: 0, max: 100, suffix: '%' })}
        {this.renderFormGroup('Message (optional)', 'text', 'giftCardMessage', { helptext: 'eg. coupon code, or other information' })}
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    regions: state.list.region,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    listRegions,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftCardForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/GiftCardForm.js
 **/